import { computed, watch } from "vue";
import { useSessionStorage } from "vue-composable";
import SelectedPlan from "src/composables/SelectedPlan";

const { is_rhythm , is_just_energy, is_txu_energy, is_apge } = SelectedPlan();

const { storage: action } = useSessionStorage('action', null);

const { storage: selected_start_date } = useSessionStorage('selected_start_date', null);

const is_selected_start_date_valid = computed(() => {
  return selected_start_date.value && /^\d{4}-\d{2}-\d{2}$/.test(selected_start_date.value)
})

const is_action_valid = computed(() => {
  return ['Move', 'Switch', 'ASAP'].includes(action.value);
})

const all_valid = computed(() => {
  if (is_rhythm.value){
    return ['Move', 'Switch'].includes(action.value) && is_selected_start_date_valid.value
  }
  else {
    return is_action_valid.value && (action.value === 'ASAP' || is_selected_start_date_valid.value)
  }
})

watch(action, () => {
  if (action.value === 'ASAP' && (!is_just_energy.value || !is_txu_energy.value || !is_apge.value)) {
    selected_start_date.value = null;
  }
})

const clear = () => {
  selected_start_date.value = null;
  action.value = null;
}

export default () => {

  return {
    action,
    is_action_valid,

    selected_start_date,
    is_selected_start_date_valid,

    all_valid,
    clear
  }
}
